





// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Editor } from "@tinymce/tinymce-react";
// import { message, Spin } from "antd";
// import {
//     BookOutlined,
//     FileImageOutlined,
//     TagsOutlined,
//     EyeOutlined,
//     CheckCircleOutlined,
//     EditOutlined,
//     SaveOutlined,
//     InfoCircleOutlined,
//     ClockCircleOutlined,
//     TeamOutlined,
//     TrophyOutlined,
//     FileTextOutlined,
//     RocketOutlined
// } from "@ant-design/icons";
// import courseService from "../../services/course.service";
// import API_BASE from "../../config/apiConfig";

// const IMAGE_PROXY_URL = `${API_BASE}/images/proxy`;

// /* 🎨 Couleurs Nomidya */
// const C = {
//     blue: "#0054A6",
//     blueDark: "#003B75",
//     blueDeep: "#002147",
//     orange: "#E8860C",
//     orangeLight: "#FF8C00",
//     orangeDark: "#C46F0A",
//     green: "#00875A",
//     text: "#1a1a1a",
//     textLight: "#6b7280",
//     border: "#e5e7eb",
// };

// const getImageUrl = (imageSource) => {
//     if (!imageSource) return "";
//     if (typeof imageSource === 'string' && imageSource.startsWith('data:image')) return imageSource;
//     if (typeof imageSource === 'string' && imageSource.startsWith('blob:')) return imageSource;
//     if (typeof imageSource === 'string' && imageSource.includes('drive.google.com')) {
//         return `${IMAGE_PROXY_URL}?url=${encodeURIComponent(imageSource)}`;
//     }
//     return imageSource;
// };

// const INITIAL_VALUE = {
//     title: "",
//     lessons: "",
//     latest_price: 1,
//     before_price: 1,
//     duration: "",
//     access_time: "À vie",
//     image: "",
//     category: "",
//     short_desc: "",
//     overview: "",
//     requirements: "",
//     what_you_will_learn: "",
//     who_is_this_course_for: "",
//     entrainements_des_connaissances: 0,
//     evaluation_des_connaissances: 0,
//     controle_des_connaissances: 0,
// };

// /* ============ COMPOSANT LOADER NOMIDYA RÉUTILISABLE ============ */
// const NomidyaLoader = ({ title, subtitle, icon = <BookOutlined /> }) => (
//     <div style={{
//         position: 'fixed',
//         top: 0, left: 0,
//         width: '100%', height: '100%',
//         background: 'rgba(0, 33, 71, 0.5)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         zIndex: 9999,
//         backdropFilter: 'blur(8px)',
//         padding: '40px 20px',
//     }}>
//         <style>{`
//             @keyframes nomidya-pulse {
//                 0%, 100% { transform: scale(1); opacity: 1; }
//                 50% { transform: scale(1.1); opacity: 0.7; }
//             }
//             @keyframes nomidya-rotate {
//                 0% { transform: rotate(0deg); }
//                 100% { transform: rotate(360deg); }
//             }
//             @keyframes nomidya-fade-in {
//                 from { opacity: 0; transform: translateY(20px); }
//                 to { opacity: 1; transform: translateY(0); }
//             }
//             @keyframes nomidya-bounce {
//                 0%, 100% { transform: translateY(0); }
//                 50% { transform: translateY(-12px); }
//             }
//             @keyframes nomidya-progress {
//                 0% { width: 0%; margin-left: 0%; }
//                 50% { width: 70%; margin-left: 15%; }
//                 100% { width: 0%; margin-left: 100%; }
//             }
//             .nomidya-loader-card {
//                 background: white;
//                 border-radius: 24px;
//                 padding: 60px 50px;
//                 box-shadow: 0 25px 50px rgba(0, 84, 166, 0.25);
//                 text-align: center;
//                 max-width: 500px;
//                 width: 100%;
//                 animation: nomidya-fade-in 0.6s ease-out;
//             }
//             .nomidya-loader-icon-wrapper {
//                 position: relative;
//                 width: 100px;
//                 height: 100px;
//                 margin: 0 auto 32px;
//             }
//             .nomidya-loader-ring {
//                 position: absolute;
//                 top: 0; left: 0;
//                 width: 100px; height: 100px;
//                 border-radius: 50%;
//                 border: 4px solid transparent;
//                 border-top-color: ${C.blue};
//                 border-right-color: ${C.orange};
//                 animation: nomidya-rotate 1.2s linear infinite;
//             }
//             .nomidya-loader-ring-2 {
//                 position: absolute;
//                 top: 10px; left: 10px;
//                 width: 80px; height: 80px;
//                 border-radius: 50%;
//                 border: 3px solid transparent;
//                 border-bottom-color: ${C.blueDark};
//                 border-left-color: ${C.orangeLight};
//                 animation: nomidya-rotate 1.5s linear infinite reverse;
//             }
//             .nomidya-loader-center {
//                 position: absolute;
//                 top: 50%; left: 50%;
//                 transform: translate(-50%, -50%);
//                 width: 50px; height: 50px;
//                 background: linear-gradient(135deg, ${C.blue} 0%, ${C.orange} 100%);
//                 border-radius: 12px;
//                 display: flex;
//                 align-items: center;
//                 justify-content: center;
//                 color: white;
//                 font-size: 24px;
//                 animation: nomidya-pulse 2s ease-in-out infinite;
//                 box-shadow: 0 8px 24px rgba(0, 84, 166, 0.3);
//             }
//             .nomidya-loader-title {
//                 font-size: 22px;
//                 font-weight: 700;
//                 color: ${C.blueDark};
//                 margin: 0 0 8px;
//             }
//             .nomidya-loader-subtitle {
//                 font-size: 14px;
//                 color: ${C.textLight};
//                 margin: 0 0 24px;
//                 line-height: 1.6;
//             }
//             .nomidya-loader-dots {
//                 display: flex;
//                 justify-content: center;
//                 gap: 10px;
//                 margin-top: 20px;
//             }
//             .nomidya-loader-dot {
//                 width: 10px;
//                 height: 10px;
//                 border-radius: 50%;
//                 animation: nomidya-bounce 1.4s ease-in-out infinite;
//             }
//             .nomidya-loader-dot:nth-child(1) { background: ${C.blue}; animation-delay: 0s; }
//             .nomidya-loader-dot:nth-child(2) { background: ${C.orange}; animation-delay: 0.2s; }
//             .nomidya-loader-dot:nth-child(3) { background: ${C.blueDark}; animation-delay: 0.4s; }
//             .nomidya-loader-progress {
//                 width: 100%;
//                 height: 4px;
//                 background: #e8eef5;
//                 border-radius: 4px;
//                 overflow: hidden;
//                 margin-top: 24px;
//             }
//             .nomidya-loader-progress-bar {
//                 height: 100%;
//                 background: linear-gradient(90deg, ${C.blue} 0%, ${C.orange} 100%);
//                 border-radius: 4px;
//                 width: 30%;
//                 animation: nomidya-progress 2s ease-in-out infinite;
//             }
//         `}</style>
//         <div className="nomidya-loader-card">
//             <div className="nomidya-loader-icon-wrapper">
//                 <div className="nomidya-loader-ring"></div>
//                 <div className="nomidya-loader-ring-2"></div>
//                 <div className="nomidya-loader-center">{icon}</div>
//             </div>
//             <h2 className="nomidya-loader-title">{title}</h2>
//             <p className="nomidya-loader-subtitle">{subtitle}</p>
//             <div className="nomidya-loader-dots">
//                 <div className="nomidya-loader-dot"></div>
//                 <div className="nomidya-loader-dot"></div>
//                 <div className="nomidya-loader-dot"></div>
//             </div>
//             <div className="nomidya-loader-progress">
//                 <div className="nomidya-loader-progress-bar"></div>
//             </div>
//         </div>
//     </div>
// );

// const CourseCreateForm = ({ btnText, initialData, onClose, onSaved }) => {
//     const [course, setCourse] = useState(INITIAL_VALUE);
//     const [imagePreview, setImagePreview] = useState("");
//     const navigate = useNavigate();
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [isLoadingData, setIsLoadingData] = useState(false);
//     const [categories, setCategories] = useState([]);
//     const [subcategories, setSubcategories] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState("");
//     const [activeSection, setActiveSection] = useState(0);

//     const calculateProgress = () => {
//         let filled = 0;
//         let total = 5;
//         if (course.title) filled++;
//         if (course.short_desc) filled++;
//         if (selectedCategory) filled++;
//         if (course.overview) filled++;
//         if (course.what_you_will_learn) filled++;
//         return Math.round((filled / total) * 100);
//     };

//     useEffect(() => {
//         if (initialData?.id) {
//             const fetchFullCourse = async () => {
//                 try {
//                     setIsLoadingData(true);
//                     const fullData = await courseService.getCourseDetails(initialData.id);
//                     setCourse({
//                         ...INITIAL_VALUE,
//                         ...fullData,
//                         entrainements_des_connaissances: fullData.entrainements_des_connaissances ?? 0,
//                         evaluation_des_connaissances: fullData.evaluation_des_connaissances ?? 0,
//                         controle_des_connaissances: fullData.controle_des_connaissances ?? 0,
//                     });
//                     const rawImageUrl = fullData.imageUrl || fullData.image || "";
//                     setImagePreview(getImageUrl(rawImageUrl));
//                     setSelectedCategory(fullData.category?.id || "");

//                     if (fullData.category?.id) {
//                         try {
//                             const subs = await courseService.getSubcategories(fullData.category.id);
//                             setSubcategories(subs);
//                         } catch (err) {
//                             console.error("Erreur sous-catégories:", err);
//                         }
//                     }
//                 } catch (error) {
//                     console.error("Erreur chargement détails:", error);
//                     message.error("Erreur lors du chargement du cours");
//                 } finally {
//                     setIsLoadingData(false);
//                 }
//             };
//             fetchFullCourse();
//         }
//     }, [initialData?.id]);

//     useEffect(() => {
//         const fetchCategories = async () => {
//             try {
//                 const response = await courseService.getCategories();
//                 if (Array.isArray(response)) setCategories(response);
//             } catch (error) {
//                 console.error("Erreur catégories :", error);
//             }
//         };
//         fetchCategories();
//     }, []);

//     const handleCategoryChange = async (e) => {
//         const categoryId = e.target.value;
//         setSelectedCategory(categoryId);
//         setCourse((prev) => ({ ...prev, category: categoryId }));
//         try {
//             const response = await courseService.getSubcategories(categoryId);
//             setSubcategories(response);
//         } catch (error) {
//             console.error("Erreur sous-catégories :", error);
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value, files, type } = e.target;
//         if (name === "image" && files && files.length > 0) {
//             setCourse((prev) => ({ ...prev, image: files[0] }));
//             setImagePreview(URL.createObjectURL(files[0]));
//         } else {
//             let processedValue = value;
//             if (type === "number") {
//                 processedValue = value === "" ? 0 : parseFloat(value) || 0;
//             }
//             setCourse((prev) => ({ ...prev, [name]: processedValue }));
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!course.title || !selectedCategory) {
//             message.error("Veuillez fournir un titre et une catégorie.");
//             return;
//         }
//         try {
//             setIsSubmitting(true);
//             let uploadedImage = course.image;
//             if (course.image instanceof File) {
//                 uploadedImage = await courseService.uploadImage(course.image);
//             }
//             const courseData = {
//                 ...course,
//                 image: uploadedImage,
//                 latest_price: 1,
//                 before_price: 1,
//                 access_time: "À vie",
//                 category: { id: selectedCategory },
//                 subcategory: course.subcategory && course.subcategory.id ? { id: course.subcategory.id } : null,
//                 entrainements_des_connaissances: initialData ? Number(course.entrainements_des_connaissances) || 0 : 0,
//                 evaluation_des_connaissances: initialData ? Number(course.evaluation_des_connaissances) || 0 : 0,
//                 controle_des_connaissances: initialData ? Number(course.controle_des_connaissances) || 0 : 0,
//             };
//             if (initialData) {
//                 await courseService.updateCourse(initialData.id, courseData, course.image);
//                 message.success("Cours mis à jour avec succès !");
//             } else {
//                 await courseService.createCourse(courseData, course.image);
//                 message.success("Cours créé avec succès !");
//             }
//             if (onSaved) {
//                 onSaved();
//             } else {
//                 setTimeout(() => navigate("/mod/courses", { replace: true }), 1500);
//             }
//         } catch (error) {
//             console.error("Erreur :", error.message);
//             message.error(error.message || "Erreur lors de l'opération !");
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     const progress = calculateProgress();

//     return (
//         <div style={{ minHeight: '100vh', background: '#f7f8fa', padding: '0' }}>
//             <style>{`
//                 .course-form-header {
//                     background: linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%);
//                     padding: 24px 32px;
//                     color: white;
//                     position: sticky;
//                     top: 0;
//                     z-index: 100;
//                     box-shadow: 0 6px 16px rgba(0, 33, 71, 0.2);
//                     overflow: hidden;
//                     position: relative;
//                 }
//                 .course-form-header::before {
//                     content: '';
//                     position: absolute;
//                     top: -100px;
//                     right: -100px;
//                     width: 300px;
//                     height: 300px;
//                     background: radial-gradient(circle, ${C.orange}22 0%, transparent 70%);
//                     border-radius: 50%;
//                     pointer-events: none;
//                 }
//                 .header-content {
//                     max-width: 1400px;
//                     margin: 0 auto;
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: center;
//                     flex-wrap: wrap;
//                     gap: 16px;
//                     position: relative;
//                     z-index: 1;
//                 }
//                 .header-title { display: flex; align-items: center; gap: 14px; }
//                 .header-title h1 { margin: 0; font-size: 24px; font-weight: 700; }
//                 .header-title .icon {
//                     font-size: 22px;
//                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
//                     padding: 12px;
//                     border-radius: 12px;
//                     box-shadow: 0 4px 12px rgba(232, 134, 12, 0.4);
//                 }
//                 .header-meta { display: flex; align-items: center; gap: 20px; }
//                 .progress-indicator {
//                     display: flex; align-items: center; gap: 10px;
//                     background: rgba(255,255,255,0.15);
//                     padding: 8px 18px; border-radius: 30px;
//                     backdrop-filter: blur(10px);
//                     border: 1px solid rgba(255,255,255,0.2);
//                 }
//                 .progress-bar-container {
//                     width: 120px; height: 6px;
//                     background: rgba(255,255,255,0.3);
//                     border-radius: 3px; overflow: hidden;
//                 }
//                 .progress-bar-fill {
//                     height: 100%; 
//                     background: linear-gradient(90deg, ${C.orange} 0%, ${C.orangeLight} 100%);
//                     border-radius: 3px; transition: width 0.3s ease;
//                 }
//                 .progress-text { font-size: 13px; font-weight: 600; }

//                 .course-form-container {
//                     max-width: 1400px;
//                     margin: 0 auto;
//                     padding: 24px;
//                     display: grid;
//                     grid-template-columns: 280px 1fr;
//                     gap: 24px;
//                 }
//                 @media (max-width: 1024px) {
//                     .course-form-container { grid-template-columns: 1fr; }
//                     .sidebar-nav { display: none; }
//                 }

//                 .sidebar-nav { position: sticky; top: 100px; height: fit-content; }
//                 .nav-card {
//                     background: white;
//                     border-radius: 16px;
//                     box-shadow: 0 4px 12px rgba(0, 84, 166, 0.06);
//                     padding: 20px;
//                     border: 1px solid ${C.border};
//                 }
//                 .nav-title {
//                     font-size: 12px; font-weight: 700;
//                     color: ${C.orange};
//                     text-transform: uppercase; letter-spacing: 1px;
//                     margin-bottom: 16px; padding-bottom: 12px;
//                     border-bottom: 2px solid ${C.orange}22;
//                 }
//                 .nav-item {
//                     display: flex; align-items: center; gap: 12px;
//                     padding: 12px 14px; margin-bottom: 6px;
//                     border-radius: 10px; cursor: pointer;
//                     transition: all 0.2s ease;
//                     color: ${C.textLight};
//                     font-size: 14px; font-weight: 500;
//                 }
//                 .nav-item:hover { 
//                     background: ${C.blue}11; 
//                     color: ${C.blue};
//                     transform: translateX(4px);
//                 }
//                 .nav-item.active {
//                     background: ${C.blue}15; 
//                     color: ${C.blue};
//                     border-left: 3px solid ${C.blue};
//                 }
//                 .nav-item .nav-icon {
//                     font-size: 18px; width: 24px;
//                     display: flex; justify-content: center;
//                 }
//                 .nav-item .check-icon {
//                     margin-left: auto;
//                     color: ${C.green}; font-size: 16px;
//                 }

//                 .form-content { display: flex; flex-direction: column; gap: 24px; }

//                 .form-section {
//                     background: white;
//                     border-radius: 16px;
//                     box-shadow: 0 4px 12px rgba(0, 84, 166, 0.06);
//                     border: 1px solid ${C.border};
//                     overflow: hidden;
//                     transition: box-shadow 0.2s ease;
//                 }
//                 .form-section:hover { box-shadow: 0 8px 20px rgba(0, 84, 166, 0.1); }

//                 .section-header {
//                     display: flex; align-items: center; gap: 14px;
//                     padding: 20px 24px;
//                     border-bottom: 1px solid ${C.border};
//                     background: linear-gradient(135deg, #f9fafb 0%, white 100%);
//                 }
//                 .section-icon {
//                     width: 44px; height: 44px;
//                     border-radius: 12px;
//                     display: flex; align-items: center; justify-content: center;
//                     font-size: 20px; color: white;
//                     box-shadow: 0 4px 10px rgba(0,0,0,0.1);
//                 }
//                 .section-icon.primary { background: linear-gradient(135deg, ${C.blue} 0%, ${C.blueDark} 100%); }
//                 .section-icon.success { background: linear-gradient(135deg, ${C.green} 0%, #059669 100%); }
//                 .section-icon.warning { background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%); }
//                 .section-icon.info { background: linear-gradient(135deg, #3b82f6 0%, ${C.blue} 100%); }
//                 .section-icon.purple { background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%); }
//                 .section-icon.pink { background: linear-gradient(135deg, #ec4899 0%, #be185d 100%); }

//                 .section-title-group h3 {
//                     margin: 0 0 4px 0; font-size: 17px; font-weight: 700;
//                     color: ${C.blueDark};
//                 }
//                 .section-title-group p {
//                     margin: 0; font-size: 13px; color: ${C.textLight};
//                 }
//                 .section-content { padding: 24px; }

//                 .form-row {
//                     display: grid;
//                     grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//                     gap: 20px;
//                 }
//                 .form-group { margin-bottom: 20px; }
//                 .form-group:last-child { margin-bottom: 0; }

//                 .form-label {
//                     display: flex; align-items: center; gap: 8px;
//                     margin-bottom: 8px;
//                     font-size: 14px; font-weight: 600;
//                     color: ${C.text};
//                 }
//                 .form-label .required { color: #ef4444; }
//                 .form-label .label-icon { color: ${C.blue}; font-size: 16px; }

//                 .form-input, .form-select, .form-textarea {
//                     width: 100%; padding: 11px 14px;
//                     border: 1.5px solid ${C.border};
//                     border-radius: 10px;
//                     font-size: 14px; color: ${C.text};
//                     background: white;
//                     transition: all 0.2s ease;
//                     box-sizing: border-box;
//                 }
//                 .form-input:hover, .form-select:hover, .form-textarea:hover {
//                     border-color: ${C.blue};
//                 }
//                 .form-input:focus, .form-select:focus, .form-textarea:focus {
//                     outline: none;
//                     border-color: ${C.blue};
//                     box-shadow: 0 0 0 3px ${C.blue}22;
//                 }
//                 .form-textarea { resize: vertical; min-height: 100px; }
//                 .form-select { cursor: pointer; }

//                 .image-upload-area {
//                     border: 2px dashed ${C.border};
//                     border-radius: 12px;
//                     padding: 24px; text-align: center;
//                     transition: all 0.2s ease;
//                     cursor: pointer;
//                     background: linear-gradient(135deg, #f9fafb 0%, white 100%);
//                 }
//                 .image-upload-area:hover {
//                     border-color: ${C.orange};
//                     background: ${C.orange}08;
//                 }
//                 .image-upload-area input[type="file"] { display: none; }

//                 .upload-icon {
//                     font-size: 40px; color: ${C.blue};
//                     margin-bottom: 12px;
//                 }
//                 .upload-text { font-size: 14px; color: ${C.text}; font-weight: 500; }
//                 .upload-hint {
//                     font-size: 12px; color: ${C.textLight}; margin-top: 6px;
//                 }

//                 .image-preview-container {
//                     position: relative;
//                     display: inline-block;
//                     margin-top: 16px;
//                 }

//                 .image-preview {
//                     max-width: 200px;
//                     max-height: 150px;
//                     border-radius: 12px;
//                     box-shadow: 0 4px 12px rgba(0, 84, 166, 0.15);
//                     border: 2px solid white;
//                     object-fit: cover;
//                 }

//                 .image-preview-badge {
//                     position: absolute;
//                     top: -8px;
//                     left: -8px;
//                     background: linear-gradient(135deg, ${C.green} 0%, #059669 100%);
//                     color: white;
//                     padding: 5px 12px;
//                     border-radius: 20px;
//                     font-size: 11px;
//                     font-weight: 700;
//                     box-shadow: 0 4px 10px rgba(0, 135, 90, 0.4);
//                     z-index: 1;
//                 }

//                 .editor-wrapper {
//                     border: 1.5px solid ${C.border};
//                     border-radius: 10px;
//                     overflow: hidden;
//                     transition: all 0.2s ease;
//                 }
//                 .editor-wrapper:focus-within {
//                     border-color: ${C.blue};
//                     box-shadow: 0 0 0 3px ${C.blue}22;
//                 }

//                 .submit-section {
//                     background: white;
//                     border-radius: 16px;
//                     box-shadow: 0 4px 12px rgba(0, 84, 166, 0.08);
//                     border: 1px solid ${C.border};
//                     padding: 24px;
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: center;
//                     flex-wrap: wrap;
//                     gap: 16px;
//                 }
//                 .submit-info {
//                     display: flex; align-items: center; gap: 12px;
//                     color: ${C.textLight}; font-size: 14px;
//                 }
//                 .submit-info .anticon { font-size: 18px; color: ${C.blue}; }
//                 .submit-actions { display: flex; gap: 12px; }

//                 .btn {
//                     display: inline-flex;
//                     align-items: center;
//                     justify-content: center;
//                     gap: 8px;
//                     padding: 12px 28px;
//                     border-radius: 12px;
//                     font-size: 15px;
//                     font-weight: 700;
//                     cursor: pointer;
//                     transition: all 0.3s ease;
//                     border: none;
//                     min-width: 160px;
//                 }
//                 .btn-primary {
//                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
//                     color: white;
//                     box-shadow: 0 6px 16px rgba(232, 134, 12, 0.4);
//                 }
//                 .btn-primary:hover:not(:disabled) {
//                     transform: translateY(-2px);
//                     box-shadow: 0 8px 20px rgba(232, 134, 12, 0.5);
//                 }
//                 .btn-primary:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

//                 .btn-secondary {
//                     background: white;
//                     color: ${C.textLight};
//                     border: 2px solid ${C.border};
//                 }
//                 .btn-secondary:hover {
//                     background: ${C.blue}08;
//                     border-color: ${C.blue};
//                     color: ${C.blue};
//                 }

//                 @media (max-width: 768px) {
//                     .course-form-header { padding: 16px 20px; }
//                     .header-title h1 { font-size: 18px; }
//                     .course-form-container { padding: 16px; }
//                     .section-content { padding: 16px; }
//                     .form-row { grid-template-columns: 1fr; }
//                     .submit-section { flex-direction: column; align-items: stretch; }
//                     .submit-actions { flex-direction: column; }
//                     .btn { width: 100%; }
//                 }
//             `}</style>

//             {/* ⭐ LOADER NOMIDYA - Chargement données */}
//             {isLoadingData && (
//                 <NomidyaLoader 
//                     title="Chargement du cours..."
//                     subtitle="Récupération des informations en cours"
//                     icon={<BookOutlined />}
//                 />
//             )}

//             {/* ⭐ LOADER NOMIDYA - Soumission */}
//             {isSubmitting && (
//                 <NomidyaLoader 
//                     title={initialData ? "Mise à jour en cours..." : "Création du cours..."}
//                     subtitle="Veuillez patienter quelques instants"
//                     icon={<SaveOutlined />}
//                 />
//             )}

//             {/* Header */}
//             <div className="course-form-header">
//                 <div className="header-content">
//                     <div className="header-title">
//                         <span className="icon">
//                             {initialData ? <EditOutlined /> : <BookOutlined />}
//                         </span>
//                         <h1>{initialData ? `Modifier : ${initialData.title || 'Cours'}` : "Créer un nouveau cours"}</h1>
//                     </div>
//                     <div className="header-meta">
//                         <div className="progress-indicator">
//                             <span className="progress-text">Progression</span>
//                             <div className="progress-bar-container">
//                                 <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
//                             </div>
//                             <span className="progress-text">{progress}%</span>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="course-form-container">
//                 <div className="sidebar-nav">
//                     <div className="nav-card">
//                         <div className="nav-title">📋 Sections du formulaire</div>
//                         <div className={`nav-item ${activeSection === 0 ? 'active' : ''}`} onClick={() => document.getElementById('section-info').scrollIntoView({ behavior: 'smooth' })}>
//                             <span className="nav-icon"><BookOutlined /></span>
//                             <span>Informations</span>
//                             {course.title && <CheckCircleOutlined className="check-icon" />}
//                         </div>
//                         <div className={`nav-item ${activeSection === 1 ? 'active' : ''}`} onClick={() => document.getElementById('section-details').scrollIntoView({ behavior: 'smooth' })}>
//                             <span className="nav-icon"><ClockCircleOutlined /></span>
//                             <span>Détails</span>
//                             {course.lessons && <CheckCircleOutlined className="check-icon" />}
//                         </div>
//                         <div className={`nav-item ${activeSection === 2 ? 'active' : ''}`} onClick={() => document.getElementById('section-category').scrollIntoView({ behavior: 'smooth' })}>
//                             <span className="nav-icon"><TagsOutlined /></span>
//                             <span>Catégorie</span>
//                             {selectedCategory && <CheckCircleOutlined className="check-icon" />}
//                         </div>
//                         <div className={`nav-item ${activeSection === 3 ? 'active' : ''}`} onClick={() => document.getElementById('section-overview').scrollIntoView({ behavior: 'smooth' })}>
//                             <span className="nav-icon"><EyeOutlined /></span>
//                             <span>Aperçu</span>
//                             {course.overview && <CheckCircleOutlined className="check-icon" />}
//                         </div>
//                         <div className={`nav-item ${activeSection === 4 ? 'active' : ''}`} onClick={() => document.getElementById('section-content').scrollIntoView({ behavior: 'smooth' })}>
//                             <span className="nav-icon"><FileTextOutlined /></span>
//                             <span>Contenu</span>
//                             {course.what_you_will_learn && <CheckCircleOutlined className="check-icon" />}
//                         </div>
//                         <div className={`nav-item ${activeSection === 5 ? 'active' : ''}`} onClick={() => document.getElementById('section-audience').scrollIntoView({ behavior: 'smooth' })}>
//                             <span className="nav-icon"><TeamOutlined /></span>
//                             <span>Public cible</span>
//                             {course.who_is_this_course_for && <CheckCircleOutlined className="check-icon" />}
//                         </div>
//                         {initialData && (
//                             <div className={`nav-item ${activeSection === 6 ? 'active' : ''}`} onClick={() => document.getElementById('section-evaluation').scrollIntoView({ behavior: 'smooth' })}>
//                                 <span className="nav-icon"><TrophyOutlined /></span>
//                                 <span>Évaluations</span>
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 <form onSubmit={handleSubmit} className="form-content">
//                     <div className="form-section" id="section-info">
//                         <div className="section-header">
//                             <div className="section-icon primary"><BookOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Informations principales</h3>
//                                 <p>Définissez le titre et la description de votre cours</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label className="form-label">
//                                         <EditOutlined className="label-icon" />
//                                         Titre du cours
//                                         <span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="title"
//                                         className="form-input"
//                                         value={course.title}
//                                         onChange={handleInputChange}
//                                         placeholder="Ex: Introduction au développement web"
//                                         required
//                                     />
//                                 </div>

//                                 <div className="form-group">
//                                     <label className="form-label">
//                                         <FileImageOutlined className="label-icon" />
//                                         Image de couverture
//                                     </label>
//                                     <label className="image-upload-area">
//                                         <input
//                                             type="file"
//                                             name="image"
//                                             onChange={handleInputChange}
//                                             accept="image/*"
//                                         />
//                                         <div className="upload-icon"><FileImageOutlined /></div>
//                                         <div className="upload-text">Cliquez pour télécharger une image</div>
//                                         <div className="upload-hint">PNG, JPG jusqu'à 5MB</div>
//                                     </label>

//                                     {imagePreview && (
//                                         <div className="image-preview-container">
//                                             {initialData && !(course.image instanceof File) && (
//                                                 <div className="image-preview-badge">
//                                                     ✓ Image actuelle
//                                                 </div>
//                                             )}
//                                             <img
//                                                 src={imagePreview}
//                                                 alt="Preview"
//                                                 className="image-preview"
//                                                 onError={(e) => {
//                                                     console.error("Erreur image preview");
//                                                     e.target.style.display = 'none';
//                                                 }}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label">
//                                     <FileTextOutlined className="label-icon" />
//                                     Description courte
//                                 </label>
//                                 <textarea
//                                     name="short_desc"
//                                     className="form-textarea"
//                                     value={course.short_desc}
//                                     onChange={handleInputChange}
//                                     placeholder="Décrivez votre cours en quelques phrases..."
//                                     rows="3"
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     <div className="form-section" id="section-details">
//                         <div className="section-header">
//                             <div className="section-icon success"><ClockCircleOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Détails du cours</h3>
//                                 <p>Précisez la durée et le nombre de leçons</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label className="form-label">
//                                         <BookOutlined className="label-icon" />
//                                         Nombre de leçons
//                                     </label>
//                                     <input
//                                         type="number"
//                                         name="lessons"
//                                         className="form-input"
//                                         value={course.lessons}
//                                         onChange={handleInputChange}
//                                         min="0"
//                                         placeholder="Ex: 12"
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label">
//                                         <ClockCircleOutlined className="label-icon" />
//                                         Durée totale
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="duration"
//                                         className="form-input"
//                                         value={course.duration}
//                                         onChange={handleInputChange}
//                                         placeholder="Ex: 4 semaines"
//                                     />
//                                 </div>
//                             </div>
//                             <input type="hidden" name="latest_price" value="1" />
//                             <input type="hidden" name="before_price" value="1" />
//                             <input type="hidden" name="access_time" value="À vie" />
//                         </div>
//                     </div>

//                     <div className="form-section" id="section-category">
//                         <div className="section-header">
//                             <div className="section-icon warning"><TagsOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Catégorisation</h3>
//                                 <p>Classez votre cours dans la bonne catégorie</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label className="form-label">
//                                         <TagsOutlined className="label-icon" />
//                                         Catégorie
//                                         <span className="required">*</span>
//                                     </label>
//                                     <select
//                                         name="category"
//                                         className="form-select"
//                                         value={selectedCategory || ""}
//                                         onChange={handleCategoryChange}
//                                         required
//                                     >
//                                         <option value="">Sélectionnez une catégorie</option>
//                                         {Array.isArray(categories) &&
//                                             categories.map((category) => (
//                                                 <option key={category.id} value={category.id}>
//                                                     {category.libelle}
//                                                 </option>
//                                             ))}
//                                     </select>
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label">
//                                         <TagsOutlined className="label-icon" />
//                                         Sous-catégorie
//                                     </label>
//                                     <select
//                                         name="subcategory"
//                                         className="form-select"
//                                         value={course.subcategory?.id || ""}
//                                         onChange={(e) =>
//                                             setCourse((prev) => ({
//                                                 ...prev,
//                                                 subcategory: e.target.value ? { id: parseInt(e.target.value, 10) } : null,
//                                             }))
//                                         }
//                                         disabled={!subcategories.length}
//                                     >
//                                         <option value="">Sélectionnez une sous-catégorie</option>
//                                         {Array.isArray(subcategories) &&
//                                             subcategories.map((subcategory) => (
//                                                 <option key={subcategory.id} value={subcategory.id}>
//                                                     {subcategory.libelle}
//                                                 </option>
//                                             ))}
//                                     </select>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="form-section" id="section-overview">
//                         <div className="section-header">
//                             <div className="section-icon info"><EyeOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Aperçu du cours</h3>
//                                 <p>Présentez les grandes lignes de votre cours</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="editor-wrapper">
//                                 <Editor
//                                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                                     value={course.overview}
//                                     init={{
//                                         height: 280,
//                                         menubar: false,
//                                         plugins: ["link", "lists", "table", "paste", "code"],
//                                         toolbar: "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | link",
//                                     }}
//                                     onEditorChange={(content) =>
//                                         handleInputChange({ target: { name: "overview", value: content } })
//                                     }
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     <div className="form-section" id="section-content">
//                         <div className="section-header">
//                             <div className="section-icon purple"><RocketOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Ce que vous allez apprendre</h3>
//                                 <p>Listez les compétences et connaissances acquises</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="editor-wrapper">
//                                 <Editor
//                                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                                     value={course.what_you_will_learn}
//                                     init={{
//                                         height: 280,
//                                         menubar: false,
//                                         plugins: ["link", "lists", "table", "paste", "code"],
//                                         toolbar: "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | link",
//                                     }}
//                                     onEditorChange={(content) =>
//                                         handleInputChange({ target: { name: "what_you_will_learn", value: content } })
//                                     }
//                                 />
//                             </div>

//                             <div className="form-group" style={{ marginTop: '24px' }}>
//                                 <label className="form-label">
//                                     <FileTextOutlined className="label-icon" />
//                                     Prérequis et exigences
//                                 </label>
//                                 <div className="editor-wrapper">
//                                     <Editor
//                                         apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                                         value={course.requirements}
//                                         init={{
//                                             height: 200,
//                                             menubar: false,
//                                             plugins: ["link", "lists", "paste"],
//                                             toolbar: "undo redo | bold italic | bullist numlist",
//                                         }}
//                                         onEditorChange={(content) =>
//                                             handleInputChange({ target: { name: "requirements", value: content } })
//                                         }
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="form-section" id="section-audience">
//                         <div className="section-header">
//                             <div className="section-icon pink"><TeamOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Public cible</h3>
//                                 <p>À qui s'adresse ce cours ?</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="editor-wrapper">
//                                 <Editor
//                                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                                     value={course.who_is_this_course_for}
//                                     init={{
//                                         height: 220,
//                                         menubar: false,
//                                         plugins: ["link", "lists", "paste"],
//                                         toolbar: "undo redo | bold italic | bullist numlist",
//                                     }}
//                                     onEditorChange={(content) =>
//                                         handleInputChange({ target: { name: "who_is_this_course_for", value: content } })
//                                     }
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {initialData && (
//                         <div className="form-section" id="section-evaluation">
//                             <div className="section-header">
//                                 <div className="section-icon success"><TrophyOutlined /></div>
//                                 <div className="section-title-group">
//                                     <h3>Les éléments du cours</h3>
//                                     <p>Configurez les pourcentages d'évaluation</p>
//                                 </div>
//                             </div>
//                             <div className="section-content">
//                                 <div className="form-row">
//                                     <div className="form-group">
//                                         <label className="form-label">
//                                             <TrophyOutlined className="label-icon" />
//                                             Entraînements (%)
//                                         </label>
//                                         <input
//                                             type="number"
//                                             name="entrainements_des_connaissances"
//                                             className="form-input"
//                                             value={course.entrainements_des_connaissances}
//                                             onChange={handleInputChange}
//                                             min="0"
//                                             max="100"
//                                             placeholder="0"
//                                         />
//                                     </div>
//                                     <div className="form-group">
//                                         <label className="form-label">
//                                             <TrophyOutlined className="label-icon" />
//                                             Évaluations (%)
//                                         </label>
//                                         <input
//                                             type="number"
//                                             name="evaluation_des_connaissances"
//                                             className="form-input"
//                                             value={course.evaluation_des_connaissances}
//                                             onChange={handleInputChange}
//                                             min="0"
//                                             max="100"
//                                             placeholder="0"
//                                         />
//                                     </div>
//                                     <div className="form-group">
//                                         <label className="form-label">
//                                             <TrophyOutlined className="label-icon" />
//                                             Contrôles (%)
//                                         </label>
//                                         <input
//                                             type="number"
//                                             name="controle_des_connaissances"
//                                             className="form-input"
//                                             value={course.controle_des_connaissances}
//                                             onChange={handleInputChange}
//                                             min="0"
//                                             max="100"
//                                             placeholder="0"
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     <div className="submit-section">
//                         <div className="submit-info">
//                             <InfoCircleOutlined />
//                             <span>Les champs marqués d'un <span style={{ color: '#ef4444' }}>*</span> sont obligatoires</span>
//                         </div>
//                         <div className="submit-actions">
//                             {onClose && (
//                                 <button type="button" className="btn btn-secondary" onClick={onClose}>
//                                     Annuler
//                                 </button>
//                             )}
//                             <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
//                                 {isSubmitting ? (
//                                     <><Spin size="small" /> Envoi...</>
//                                 ) : (
//                                     <><SaveOutlined /> {initialData ? "Mettre à jour" : "Créer le cours"}</>
//                                 )}
//                             </button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default CourseCreateForm;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { message, Spin } from "antd";
import {
    BookOutlined,
    FileImageOutlined,
    TagsOutlined,
    EyeOutlined,
    CheckCircleOutlined,
    EditOutlined,
    SaveOutlined,
    InfoCircleOutlined,
    ClockCircleOutlined,
    TeamOutlined,
    TrophyOutlined,
    FileTextOutlined,
    RocketOutlined
} from "@ant-design/icons";
import courseService from "../../services/course.service";
import API_BASE from "../../config/apiConfig";

const IMAGE_PROXY_URL = `${API_BASE}/images/proxy`;

/* 🎨 Couleurs Nomidya */
const C = {
    blue: "#0054A6",
    blueDark: "#003B75",
    blueDeep: "#002147",
    orange: "#E8860C",
    orangeLight: "#FF8C00",
    orangeDark: "#C46F0A",
    green: "#00875A",
    text: "#1a1a1a",
    textLight: "#6b7280",
    border: "#e5e7eb",
};

const getImageUrl = (imageSource) => {
    if (!imageSource) return "";
    if (typeof imageSource === 'string' && imageSource.startsWith('data:image')) return imageSource;
    if (typeof imageSource === 'string' && imageSource.startsWith('blob:')) return imageSource;
    if (typeof imageSource === 'string' && imageSource.includes('drive.google.com')) {
        return `${IMAGE_PROXY_URL}?url=${encodeURIComponent(imageSource)}`;
    }
    return imageSource;
};

const INITIAL_VALUE = {
    title: "",
    lessons: "",
    latest_price: 1,
    before_price: 1,
    duration: "",
    access_time: "À vie",
    image: "",
    category: "",
    short_desc: "",
    overview: "",
    requirements: "",
    what_you_will_learn: "",
    who_is_this_course_for: "",
    entrainements_des_connaissances: 0,
    evaluation_des_connaissances: 0,
    controle_des_connaissances: 0,
};

/* ============ COMPOSANT LOADER NOMIDYA RÉUTILISABLE ============ */
const NomidyaLoader = ({ title, subtitle, icon = <BookOutlined /> }) => (
    <div style={{
        position: 'fixed',
        top: 0, left: 0,
        width: '100%', height: '100%',
        background: 'rgba(0, 33, 71, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(8px)',
        padding: '40px 20px',
    }}>
        <style>{`
            @keyframes nomidya-pulse {
                0%, 100% { transform: scale(1); opacity: 1; }
                50% { transform: scale(1.1); opacity: 0.7; }
            }
            @keyframes nomidya-rotate {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            @keyframes nomidya-fade-in {
                from { opacity: 0; transform: translateY(20px); }
                to { opacity: 1; transform: translateY(0); }
            }
            @keyframes nomidya-bounce {
                0%, 100% { transform: translateY(0); }
                50% { transform: translateY(-12px); }
            }
            @keyframes nomidya-progress {
                0% { width: 0%; margin-left: 0%; }
                50% { width: 70%; margin-left: 15%; }
                100% { width: 0%; margin-left: 100%; }
            }
            .nomidya-loader-card {
                background: white;
                border-radius: 24px;
                padding: 60px 50px;
                box-shadow: 0 25px 50px rgba(0, 84, 166, 0.25);
                text-align: center;
                max-width: 500px;
                width: 100%;
                animation: nomidya-fade-in 0.6s ease-out;
            }
            .nomidya-loader-icon-wrapper {
                position: relative;
                width: 100px;
                height: 100px;
                margin: 0 auto 32px;
            }
            .nomidya-loader-ring {
                position: absolute;
                top: 0; left: 0;
                width: 100px; height: 100px;
                border-radius: 50%;
                border: 4px solid transparent;
                border-top-color: ${C.blue};
                border-right-color: ${C.orange};
                animation: nomidya-rotate 1.2s linear infinite;
            }
            .nomidya-loader-ring-2 {
                position: absolute;
                top: 10px; left: 10px;
                width: 80px; height: 80px;
                border-radius: 50%;
                border: 3px solid transparent;
                border-bottom-color: ${C.blueDark};
                border-left-color: ${C.orangeLight};
                animation: nomidya-rotate 1.5s linear infinite reverse;
            }
            .nomidya-loader-center {
                position: absolute;
                top: 50%; left: 50%;
                transform: translate(-50%, -50%);
                width: 50px; height: 50px;
                background: linear-gradient(135deg, ${C.blue} 0%, ${C.orange} 100%);
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-size: 24px;
                animation: nomidya-pulse 2s ease-in-out infinite;
                box-shadow: 0 8px 24px rgba(0, 84, 166, 0.3);
            }
            .nomidya-loader-title {
                font-size: 22px;
                font-weight: 700;
                color: ${C.blueDark};
                margin: 0 0 8px;
            }
            .nomidya-loader-subtitle {
                font-size: 14px;
                color: ${C.textLight};
                margin: 0 0 24px;
                line-height: 1.6;
            }
            .nomidya-loader-dots {
                display: flex;
                justify-content: center;
                gap: 10px;
                margin-top: 20px;
            }
            .nomidya-loader-dot {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                animation: nomidya-bounce 1.4s ease-in-out infinite;
            }
            .nomidya-loader-dot:nth-child(1) { background: ${C.blue}; animation-delay: 0s; }
            .nomidya-loader-dot:nth-child(2) { background: ${C.orange}; animation-delay: 0.2s; }
            .nomidya-loader-dot:nth-child(3) { background: ${C.blueDark}; animation-delay: 0.4s; }
            .nomidya-loader-progress {
                width: 100%;
                height: 4px;
                background: #e8eef5;
                border-radius: 4px;
                overflow: hidden;
                margin-top: 24px;
            }
            .nomidya-loader-progress-bar {
                height: 100%;
                background: linear-gradient(90deg, ${C.blue} 0%, ${C.orange} 100%);
                border-radius: 4px;
                width: 30%;
                animation: nomidya-progress 2s ease-in-out infinite;
            }
        `}</style>
        <div className="nomidya-loader-card">
            <div className="nomidya-loader-icon-wrapper">
                <div className="nomidya-loader-ring"></div>
                <div className="nomidya-loader-ring-2"></div>
                <div className="nomidya-loader-center">{icon}</div>
            </div>
            <h2 className="nomidya-loader-title">{title}</h2>
            <p className="nomidya-loader-subtitle">{subtitle}</p>
            <div className="nomidya-loader-dots">
                <div className="nomidya-loader-dot"></div>
                <div className="nomidya-loader-dot"></div>
                <div className="nomidya-loader-dot"></div>
            </div>
            <div className="nomidya-loader-progress">
                <div className="nomidya-loader-progress-bar"></div>
            </div>
        </div>
    </div>
);

const CourseCreateForm = ({ btnText, initialData, onClose, onSaved }) => {
    const [course, setCourse] = useState(INITIAL_VALUE);
    const [imagePreview, setImagePreview] = useState("");
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [activeSection, setActiveSection] = useState(0);

    const calculateProgress = () => {
        let filled = 0;
        let total = 5;
        if (course.title) filled++;
        if (course.short_desc) filled++;
        if (selectedCategory) filled++;
        if (course.overview) filled++;
        if (course.what_you_will_learn) filled++;
        return Math.round((filled / total) * 100);
    };

    useEffect(() => {
        if (initialData?.id) {
            const fetchFullCourse = async () => {
                try {
                    setIsLoadingData(true);
                    const fullData = await courseService.getCourseDetails(initialData.id);
                    setCourse({
                        ...INITIAL_VALUE,
                        ...fullData,
                        entrainements_des_connaissances: fullData.entrainements_des_connaissances ?? 0,
                        evaluation_des_connaissances: fullData.evaluation_des_connaissances ?? 0,
                        controle_des_connaissances: fullData.controle_des_connaissances ?? 0,
                    });
                    const rawImageUrl = fullData.imageUrl || fullData.image || "";
                    setImagePreview(getImageUrl(rawImageUrl));
                    setSelectedCategory(fullData.category?.id || "");

                    if (fullData.category?.id) {
                        try {
                            const subs = await courseService.getSubcategories(fullData.category.id);
                            setSubcategories(subs);
                        } catch (err) {
                            console.error("Erreur sous-catégories:", err);
                        }
                    }
                } catch (error) {
                    console.error("Erreur chargement détails:", error);
                    message.error("Erreur lors du chargement du cours");
                } finally {
                    setIsLoadingData(false);
                }
            };
            fetchFullCourse();
        }
    }, [initialData?.id]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await courseService.getCategories();
                if (Array.isArray(response)) setCategories(response);
            } catch (error) {
                console.error("Erreur catégories :", error);
            }
        };
        fetchCategories();
    }, []);

    const handleCategoryChange = async (e) => {
        const categoryId = e.target.value;
        setSelectedCategory(categoryId);
        setCourse((prev) => ({ ...prev, category: categoryId }));
        try {
            const response = await courseService.getSubcategories(categoryId);
            setSubcategories(response);
        } catch (error) {
            console.error("Erreur sous-catégories :", error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, files, type } = e.target;
        if (name === "image" && files && files.length > 0) {
            setCourse((prev) => ({ ...prev, image: files[0] }));
            setImagePreview(URL.createObjectURL(files[0]));
        } else {
            let processedValue = value;
            if (type === "number") {
                processedValue = value === "" ? 0 : parseFloat(value) || 0;
            }
            setCourse((prev) => ({ ...prev, [name]: processedValue }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // ✅ Empêcher la sauvegarde tant que les données ne sont pas chargées
        //    (évite que des champs vides écrasent les vraies valeurs)
        if (isLoadingData) {
            message.warning("Veuillez attendre la fin du chargement du cours.");
            return;
        }

        if (!course.title || !selectedCategory) {
            message.error("Veuillez fournir un titre et une catégorie.");
            return;
        }
        try {
            setIsSubmitting(true);
            let uploadedImage = course.image;
            if (course.image instanceof File) {
                uploadedImage = await courseService.uploadImage(course.image);
            }
            const courseData = {
                ...course,
                image: uploadedImage,
                // ✅ À la CRÉATION : prix et accès par défaut.
                //    À la MODIFICATION : on PRÉSERVE les valeurs existantes du cours
                //    (au lieu de les forcer à 1, ce qui écrasait le vrai prix).
                latest_price: initialData
                    ? (course.latest_price ?? 1)
                    : 1,
                before_price: initialData
                    ? (course.before_price ?? 1)
                    : 1,
                access_time: initialData
                    ? (course.access_time || "À vie")
                    : "À vie",
                category: { id: selectedCategory },
                subcategory: course.subcategory && course.subcategory.id ? { id: course.subcategory.id } : null,
                entrainements_des_connaissances: initialData ? Number(course.entrainements_des_connaissances) || 0 : 0,
                evaluation_des_connaissances: initialData ? Number(course.evaluation_des_connaissances) || 0 : 0,
                controle_des_connaissances: initialData ? Number(course.controle_des_connaissances) || 0 : 0,
            };
            if (initialData) {
                await courseService.updateCourse(initialData.id, courseData, course.image);
                message.success("Cours mis à jour avec succès !");
            } else {
                await courseService.createCourse(courseData, course.image);
                message.success("Cours créé avec succès !");
            }
            if (onSaved) {
                onSaved();
            } else {
                setTimeout(() => navigate("/mod/courses", { replace: true }), 1500);
            }
        } catch (error) {
            console.error("Erreur :", error.message);
            message.error(error.message || "Erreur lors de l'opération !");
        } finally {
            setIsSubmitting(false);
        }
    };

    const progress = calculateProgress();

    return (
        <div style={{ minHeight: '100vh', background: '#f7f8fa', padding: '0' }}>
            <style>{`
                .course-form-header {
                    background: linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%);
                    padding: 24px 32px;
                    color: white;
                    position: sticky;
                    top: 0;
                    z-index: 100;
                    box-shadow: 0 6px 16px rgba(0, 33, 71, 0.2);
                    overflow: hidden;
                    position: relative;
                }
                .course-form-header::before {
                    content: '';
                    position: absolute;
                    top: -100px;
                    right: -100px;
                    width: 300px;
                    height: 300px;
                    background: radial-gradient(circle, ${C.orange}22 0%, transparent 70%);
                    border-radius: 50%;
                    pointer-events: none;
                }
                .header-content {
                    max-width: 1400px;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 16px;
                    position: relative;
                    z-index: 1;
                }
                .header-title { display: flex; align-items: center; gap: 14px; }
                .header-title h1 { margin: 0; font-size: 24px; font-weight: 700; }
                .header-title .icon {
                    font-size: 22px;
                    background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
                    padding: 12px;
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(232, 134, 12, 0.4);
                }
                .header-meta { display: flex; align-items: center; gap: 20px; }
                .progress-indicator {
                    display: flex; align-items: center; gap: 10px;
                    background: rgba(255,255,255,0.15);
                    padding: 8px 18px; border-radius: 30px;
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255,255,255,0.2);
                }
                .progress-bar-container {
                    width: 120px; height: 6px;
                    background: rgba(255,255,255,0.3);
                    border-radius: 3px; overflow: hidden;
                }
                .progress-bar-fill {
                    height: 100%; 
                    background: linear-gradient(90deg, ${C.orange} 0%, ${C.orangeLight} 100%);
                    border-radius: 3px; transition: width 0.3s ease;
                }
                .progress-text { font-size: 13px; font-weight: 600; }

                .course-form-container {
                    max-width: 1400px;
                    margin: 0 auto;
                    padding: 24px;
                    display: grid;
                    grid-template-columns: 280px 1fr;
                    gap: 24px;
                }
                @media (max-width: 1024px) {
                    .course-form-container { grid-template-columns: 1fr; }
                    .sidebar-nav { display: none; }
                }

                .sidebar-nav { position: sticky; top: 100px; height: fit-content; }
                .nav-card {
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 4px 12px rgba(0, 84, 166, 0.06);
                    padding: 20px;
                    border: 1px solid ${C.border};
                }
                .nav-title {
                    font-size: 12px; font-weight: 700;
                    color: ${C.orange};
                    text-transform: uppercase; letter-spacing: 1px;
                    margin-bottom: 16px; padding-bottom: 12px;
                    border-bottom: 2px solid ${C.orange}22;
                }
                .nav-item {
                    display: flex; align-items: center; gap: 12px;
                    padding: 12px 14px; margin-bottom: 6px;
                    border-radius: 10px; cursor: pointer;
                    transition: all 0.2s ease;
                    color: ${C.textLight};
                    font-size: 14px; font-weight: 500;
                }
                .nav-item:hover { 
                    background: ${C.blue}11; 
                    color: ${C.blue};
                    transform: translateX(4px);
                }
                .nav-item.active {
                    background: ${C.blue}15; 
                    color: ${C.blue};
                    border-left: 3px solid ${C.blue};
                }
                .nav-item .nav-icon {
                    font-size: 18px; width: 24px;
                    display: flex; justify-content: center;
                }
                .nav-item .check-icon {
                    margin-left: auto;
                    color: ${C.green}; font-size: 16px;
                }

                .form-content { display: flex; flex-direction: column; gap: 24px; }

                .form-section {
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 4px 12px rgba(0, 84, 166, 0.06);
                    border: 1px solid ${C.border};
                    overflow: hidden;
                    transition: box-shadow 0.2s ease;
                }
                .form-section:hover { box-shadow: 0 8px 20px rgba(0, 84, 166, 0.1); }

                .section-header {
                    display: flex; align-items: center; gap: 14px;
                    padding: 20px 24px;
                    border-bottom: 1px solid ${C.border};
                    background: linear-gradient(135deg, #f9fafb 0%, white 100%);
                }
                .section-icon {
                    width: 44px; height: 44px;
                    border-radius: 12px;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 20px; color: white;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
                }
                .section-icon.primary { background: linear-gradient(135deg, ${C.blue} 0%, ${C.blueDark} 100%); }
                .section-icon.success { background: linear-gradient(135deg, ${C.green} 0%, #059669 100%); }
                .section-icon.warning { background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%); }
                .section-icon.info { background: linear-gradient(135deg, #3b82f6 0%, ${C.blue} 100%); }
                .section-icon.purple { background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%); }
                .section-icon.pink { background: linear-gradient(135deg, #ec4899 0%, #be185d 100%); }

                .section-title-group h3 {
                    margin: 0 0 4px 0; font-size: 17px; font-weight: 700;
                    color: ${C.blueDark};
                }
                .section-title-group p {
                    margin: 0; font-size: 13px; color: ${C.textLight};
                }
                .section-content { padding: 24px; }

                .form-row {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 20px;
                }
                .form-group { margin-bottom: 20px; }
                .form-group:last-child { margin-bottom: 0; }

                .form-label {
                    display: flex; align-items: center; gap: 8px;
                    margin-bottom: 8px;
                    font-size: 14px; font-weight: 600;
                    color: ${C.text};
                }
                .form-label .required { color: #ef4444; }
                .form-label .label-icon { color: ${C.blue}; font-size: 16px; }

                .form-input, .form-select, .form-textarea {
                    width: 100%; padding: 11px 14px;
                    border: 1.5px solid ${C.border};
                    border-radius: 10px;
                    font-size: 14px; color: ${C.text};
                    background: white;
                    transition: all 0.2s ease;
                    box-sizing: border-box;
                }
                .form-input:hover, .form-select:hover, .form-textarea:hover {
                    border-color: ${C.blue};
                }
                .form-input:focus, .form-select:focus, .form-textarea:focus {
                    outline: none;
                    border-color: ${C.blue};
                    box-shadow: 0 0 0 3px ${C.blue}22;
                }
                .form-textarea { resize: vertical; min-height: 100px; }
                .form-select { cursor: pointer; }

                .image-upload-area {
                    border: 2px dashed ${C.border};
                    border-radius: 12px;
                    padding: 24px; text-align: center;
                    transition: all 0.2s ease;
                    cursor: pointer;
                    background: linear-gradient(135deg, #f9fafb 0%, white 100%);
                }
                .image-upload-area:hover {
                    border-color: ${C.orange};
                    background: ${C.orange}08;
                }
                .image-upload-area input[type="file"] { display: none; }

                .upload-icon {
                    font-size: 40px; color: ${C.blue};
                    margin-bottom: 12px;
                }
                .upload-text { font-size: 14px; color: ${C.text}; font-weight: 500; }
                .upload-hint {
                    font-size: 12px; color: ${C.textLight}; margin-top: 6px;
                }

                .image-preview-container {
                    position: relative;
                    display: inline-block;
                    margin-top: 16px;
                }

                .image-preview {
                    max-width: 200px;
                    max-height: 150px;
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0, 84, 166, 0.15);
                    border: 2px solid white;
                    object-fit: cover;
                }

                .image-preview-badge {
                    position: absolute;
                    top: -8px;
                    left: -8px;
                    background: linear-gradient(135deg, ${C.green} 0%, #059669 100%);
                    color: white;
                    padding: 5px 12px;
                    border-radius: 20px;
                    font-size: 11px;
                    font-weight: 700;
                    box-shadow: 0 4px 10px rgba(0, 135, 90, 0.4);
                    z-index: 1;
                }

                .editor-wrapper {
                    border: 1.5px solid ${C.border};
                    border-radius: 10px;
                    overflow: hidden;
                    transition: all 0.2s ease;
                }
                .editor-wrapper:focus-within {
                    border-color: ${C.blue};
                    box-shadow: 0 0 0 3px ${C.blue}22;
                }

                .submit-section {
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 4px 12px rgba(0, 84, 166, 0.08);
                    border: 1px solid ${C.border};
                    padding: 24px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 16px;
                }
                .submit-info {
                    display: flex; align-items: center; gap: 12px;
                    color: ${C.textLight}; font-size: 14px;
                }
                .submit-info .anticon { font-size: 18px; color: ${C.blue}; }
                .submit-actions { display: flex; gap: 12px; }

                .btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 12px 28px;
                    border-radius: 12px;
                    font-size: 15px;
                    font-weight: 700;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    border: none;
                    min-width: 160px;
                }
                .btn-primary {
                    background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
                    color: white;
                    box-shadow: 0 6px 16px rgba(232, 134, 12, 0.4);
                }
                .btn-primary:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px rgba(232, 134, 12, 0.5);
                }
                .btn-primary:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

                .btn-secondary {
                    background: white;
                    color: ${C.textLight};
                    border: 2px solid ${C.border};
                }
                .btn-secondary:hover {
                    background: ${C.blue}08;
                    border-color: ${C.blue};
                    color: ${C.blue};
                }

                @media (max-width: 768px) {
                    .course-form-header { padding: 16px 20px; }
                    .header-title h1 { font-size: 18px; }
                    .course-form-container { padding: 16px; }
                    .section-content { padding: 16px; }
                    .form-row { grid-template-columns: 1fr; }
                    .submit-section { flex-direction: column; align-items: stretch; }
                    .submit-actions { flex-direction: column; }
                    .btn { width: 100%; }
                }
            `}</style>

            {/* ⭐ LOADER NOMIDYA - Chargement données */}
            {isLoadingData && (
                <NomidyaLoader 
                    title="Chargement du cours..."
                    subtitle="Récupération des informations en cours"
                    icon={<BookOutlined />}
                />
            )}

            {/* ⭐ LOADER NOMIDYA - Soumission */}
            {isSubmitting && (
                <NomidyaLoader 
                    title={initialData ? "Mise à jour en cours..." : "Création du cours..."}
                    subtitle="Veuillez patienter quelques instants"
                    icon={<SaveOutlined />}
                />
            )}

            {/* Header */}
            <div className="course-form-header">
                <div className="header-content">
                    <div className="header-title">
                        <span className="icon">
                            {initialData ? <EditOutlined /> : <BookOutlined />}
                        </span>
                        <h1>{initialData ? `Modifier : ${initialData.title || 'Cours'}` : "Créer un nouveau cours"}</h1>
                    </div>
                    <div className="header-meta">
                        <div className="progress-indicator">
                            <span className="progress-text">Progression</span>
                            <div className="progress-bar-container">
                                <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
                            </div>
                            <span className="progress-text">{progress}%</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="course-form-container">
                <div className="sidebar-nav">
                    <div className="nav-card">
                        <div className="nav-title">📋 Sections du formulaire</div>
                        <div className={`nav-item ${activeSection === 0 ? 'active' : ''}`} onClick={() => document.getElementById('section-info').scrollIntoView({ behavior: 'smooth' })}>
                            <span className="nav-icon"><BookOutlined /></span>
                            <span>Informations</span>
                            {course.title && <CheckCircleOutlined className="check-icon" />}
                        </div>
                        <div className={`nav-item ${activeSection === 1 ? 'active' : ''}`} onClick={() => document.getElementById('section-details').scrollIntoView({ behavior: 'smooth' })}>
                            <span className="nav-icon"><ClockCircleOutlined /></span>
                            <span>Détails</span>
                            {course.lessons && <CheckCircleOutlined className="check-icon" />}
                        </div>
                        <div className={`nav-item ${activeSection === 2 ? 'active' : ''}`} onClick={() => document.getElementById('section-category').scrollIntoView({ behavior: 'smooth' })}>
                            <span className="nav-icon"><TagsOutlined /></span>
                            <span>Catégorie</span>
                            {selectedCategory && <CheckCircleOutlined className="check-icon" />}
                        </div>
                        <div className={`nav-item ${activeSection === 3 ? 'active' : ''}`} onClick={() => document.getElementById('section-overview').scrollIntoView({ behavior: 'smooth' })}>
                            <span className="nav-icon"><EyeOutlined /></span>
                            <span>Aperçu</span>
                            {course.overview && <CheckCircleOutlined className="check-icon" />}
                        </div>
                        <div className={`nav-item ${activeSection === 4 ? 'active' : ''}`} onClick={() => document.getElementById('section-content').scrollIntoView({ behavior: 'smooth' })}>
                            <span className="nav-icon"><FileTextOutlined /></span>
                            <span>Contenu</span>
                            {course.what_you_will_learn && <CheckCircleOutlined className="check-icon" />}
                        </div>
                        <div className={`nav-item ${activeSection === 5 ? 'active' : ''}`} onClick={() => document.getElementById('section-audience').scrollIntoView({ behavior: 'smooth' })}>
                            <span className="nav-icon"><TeamOutlined /></span>
                            <span>Public cible</span>
                            {course.who_is_this_course_for && <CheckCircleOutlined className="check-icon" />}
                        </div>
                        {initialData && (
                            <div className={`nav-item ${activeSection === 6 ? 'active' : ''}`} onClick={() => document.getElementById('section-evaluation').scrollIntoView({ behavior: 'smooth' })}>
                                <span className="nav-icon"><TrophyOutlined /></span>
                                <span>Évaluations</span>
                            </div>
                        )}
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="form-content">
                    <div className="form-section" id="section-info">
                        <div className="section-header">
                            <div className="section-icon primary"><BookOutlined /></div>
                            <div className="section-title-group">
                                <h3>Informations principales</h3>
                                <p>Définissez le titre et la description de votre cours</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="form-row">
                                <div className="form-group">
                                    <label className="form-label">
                                        <EditOutlined className="label-icon" />
                                        Titre du cours
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="title"
                                        className="form-input"
                                        value={course.title}
                                        onChange={handleInputChange}
                                        placeholder="Ex: Introduction au développement web"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label className="form-label">
                                        <FileImageOutlined className="label-icon" />
                                        Image de couverture
                                    </label>
                                    <label className="image-upload-area">
                                        <input
                                            type="file"
                                            name="image"
                                            onChange={handleInputChange}
                                            accept="image/*"
                                        />
                                        <div className="upload-icon"><FileImageOutlined /></div>
                                        <div className="upload-text">Cliquez pour télécharger une image</div>
                                        <div className="upload-hint">PNG, JPG jusqu'à 5MB</div>
                                    </label>

                                    {imagePreview && (
                                        <div className="image-preview-container">
                                            {initialData && !(course.image instanceof File) && (
                                                <div className="image-preview-badge">
                                                    ✓ Image actuelle
                                                </div>
                                            )}
                                            <img
                                                src={imagePreview}
                                                alt="Preview"
                                                className="image-preview"
                                                onError={(e) => {
                                                    console.error("Erreur image preview");
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    <FileTextOutlined className="label-icon" />
                                    Description courte
                                </label>
                                <textarea
                                    name="short_desc"
                                    className="form-textarea"
                                    value={course.short_desc}
                                    onChange={handleInputChange}
                                    placeholder="Décrivez votre cours en quelques phrases..."
                                    rows="3"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-section" id="section-details">
                        <div className="section-header">
                            <div className="section-icon success"><ClockCircleOutlined /></div>
                            <div className="section-title-group">
                                <h3>Détails du cours</h3>
                                <p>Précisez la durée et le nombre de leçons</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="form-row">
                                <div className="form-group">
                                    <label className="form-label">
                                        <BookOutlined className="label-icon" />
                                        Nombre de leçons
                                    </label>
                                    <input
                                        type="number"
                                        name="lessons"
                                        className="form-input"
                                        value={course.lessons}
                                        onChange={handleInputChange}
                                        min="0"
                                        placeholder="Ex: 12"
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">
                                        <ClockCircleOutlined className="label-icon" />
                                        Durée totale
                                    </label>
                                    <input
                                        type="text"
                                        name="duration"
                                        className="form-input"
                                        value={course.duration}
                                        onChange={handleInputChange}
                                        placeholder="Ex: 4 semaines"
                                    />
                                </div>
                            </div>
                            {/* ✅ Inputs cachés supprimés : ils forçaient prix/accès à 1 et
                                entretenaient la confusion. Les valeurs sont gérées dans handleSubmit. */}
                        </div>
                    </div>

                    <div className="form-section" id="section-category">
                        <div className="section-header">
                            <div className="section-icon warning"><TagsOutlined /></div>
                            <div className="section-title-group">
                                <h3>Catégorisation</h3>
                                <p>Classez votre cours dans la bonne catégorie</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="form-row">
                                <div className="form-group">
                                    <label className="form-label">
                                        <TagsOutlined className="label-icon" />
                                        Catégorie
                                        <span className="required">*</span>
                                    </label>
                                    <select
                                        name="category"
                                        className="form-select"
                                        value={selectedCategory || ""}
                                        onChange={handleCategoryChange}
                                        required
                                    >
                                        <option value="">Sélectionnez une catégorie</option>
                                        {Array.isArray(categories) &&
                                            categories.map((category) => (
                                                <option key={category.id} value={category.id}>
                                                    {category.libelle}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label className="form-label">
                                        <TagsOutlined className="label-icon" />
                                        Sous-catégorie
                                    </label>
                                    <select
                                        name="subcategory"
                                        className="form-select"
                                        value={course.subcategory?.id || ""}
                                        onChange={(e) =>
                                            setCourse((prev) => ({
                                                ...prev,
                                                subcategory: e.target.value ? { id: parseInt(e.target.value, 10) } : null,
                                            }))
                                        }
                                        disabled={!subcategories.length}
                                    >
                                        <option value="">Sélectionnez une sous-catégorie</option>
                                        {Array.isArray(subcategories) &&
                                            subcategories.map((subcategory) => (
                                                <option key={subcategory.id} value={subcategory.id}>
                                                    {subcategory.libelle}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-section" id="section-overview">
                        <div className="section-header">
                            <div className="section-icon info"><EyeOutlined /></div>
                            <div className="section-title-group">
                                <h3>Aperçu du cours</h3>
                                <p>Présentez les grandes lignes de votre cours</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="editor-wrapper">
                                <Editor
                                    apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                                    value={course.overview}
                                    init={{
                                        height: 280,
                                        menubar: false,
                                        plugins: ["link", "lists", "table", "paste", "code"],
                                        toolbar: "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | link",
                                    }}
                                    onEditorChange={(content) =>
                                        handleInputChange({ target: { name: "overview", value: content } })
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-section" id="section-content">
                        <div className="section-header">
                            <div className="section-icon purple"><RocketOutlined /></div>
                            <div className="section-title-group">
                                <h3>Ce que vous allez apprendre</h3>
                                <p>Listez les compétences et connaissances acquises</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="editor-wrapper">
                                <Editor
                                    apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                                    value={course.what_you_will_learn}
                                    init={{
                                        height: 280,
                                        menubar: false,
                                        plugins: ["link", "lists", "table", "paste", "code"],
                                        toolbar: "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | link",
                                    }}
                                    onEditorChange={(content) =>
                                        handleInputChange({ target: { name: "what_you_will_learn", value: content } })
                                    }
                                />
                            </div>

                            <div className="form-group" style={{ marginTop: '24px' }}>
                                <label className="form-label">
                                    <FileTextOutlined className="label-icon" />
                                    Prérequis et exigences
                                </label>
                                <div className="editor-wrapper">
                                    <Editor
                                        apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                                        value={course.requirements}
                                        init={{
                                            height: 200,
                                            menubar: false,
                                            plugins: ["link", "lists", "paste"],
                                            toolbar: "undo redo | bold italic | bullist numlist",
                                        }}
                                        onEditorChange={(content) =>
                                            handleInputChange({ target: { name: "requirements", value: content } })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-section" id="section-audience">
                        <div className="section-header">
                            <div className="section-icon pink"><TeamOutlined /></div>
                            <div className="section-title-group">
                                <h3>Public cible</h3>
                                <p>À qui s'adresse ce cours ?</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="editor-wrapper">
                                <Editor
                                    apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                                    value={course.who_is_this_course_for}
                                    init={{
                                        height: 220,
                                        menubar: false,
                                        plugins: ["link", "lists", "paste"],
                                        toolbar: "undo redo | bold italic | bullist numlist",
                                    }}
                                    onEditorChange={(content) =>
                                        handleInputChange({ target: { name: "who_is_this_course_for", value: content } })
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    {initialData && (
                        <div className="form-section" id="section-evaluation">
                            <div className="section-header">
                                <div className="section-icon success"><TrophyOutlined /></div>
                                <div className="section-title-group">
                                    <h3>Les éléments du cours</h3>
                                    <p>Configurez les pourcentages d'évaluation</p>
                                </div>
                            </div>
                            <div className="section-content">
                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="form-label">
                                            <TrophyOutlined className="label-icon" />
                                            Entraînements (%)
                                        </label>
                                        <input
                                            type="number"
                                            name="entrainements_des_connaissances"
                                            className="form-input"
                                            value={course.entrainements_des_connaissances}
                                            onChange={handleInputChange}
                                            min="0"
                                            max="100"
                                            placeholder="0"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">
                                            <TrophyOutlined className="label-icon" />
                                            Évaluations (%)
                                        </label>
                                        <input
                                            type="number"
                                            name="evaluation_des_connaissances"
                                            className="form-input"
                                            value={course.evaluation_des_connaissances}
                                            onChange={handleInputChange}
                                            min="0"
                                            max="100"
                                            placeholder="0"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">
                                            <TrophyOutlined className="label-icon" />
                                            Contrôles (%)
                                        </label>
                                        <input
                                            type="number"
                                            name="controle_des_connaissances"
                                            className="form-input"
                                            value={course.controle_des_connaissances}
                                            onChange={handleInputChange}
                                            min="0"
                                            max="100"
                                            placeholder="0"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="submit-section">
                        <div className="submit-info">
                            <InfoCircleOutlined />
                            <span>Les champs marqués d'un <span style={{ color: '#ef4444' }}>*</span> sont obligatoires</span>
                        </div>
                        <div className="submit-actions">
                            {onClose && (
                                <button type="button" className="btn btn-secondary" onClick={onClose}>
                                    Annuler
                                </button>
                            )}
                            <button type="submit" className="btn btn-primary" disabled={isSubmitting || isLoadingData}>
                                {isSubmitting ? (
                                    <><Spin size="small" /> Envoi...</>
                                ) : (
                                    <><SaveOutlined /> {initialData ? "Mettre à jour" : "Créer le cours"}</>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CourseCreateForm;